export const LOGIN_IMG = './assets/img/login-page.jpg'
export const USER_AVATAR = './assets/img/user.png'
export const ADMIN_AVATAR = './assets/img/admin.png'
export const SPLASH_SERVICES = './assets/img/splash_services.jpg'
